import { UseKlydoMutationOptions } from "../../../components/hooks/useKlydoMutation";
import uploadsApiClient, {
  UploadFileInput,
  UploadResponse,
} from "../../../api/uploads";
import useUploadMutation from "./useUploadMutation";

const useUploadCollectionThumbnailBackgroundMutation = (
  options: Omit<
    UseKlydoMutationOptions<
      UploadResponse,
      UploadFileInput,
      { previousUploadStatus: UploadResponse | undefined }
    >,
    "onSuccess" | "onSettled"
  > & {
    onSuccess?: (response: UploadResponse) => void;
    onSettled?: (response: UploadResponse | undefined, error: unknown) => void;
  } = {},
) => {
  return useUploadMutation(
    uploadsApiClient.uploadCollectionThumbnailBackground,
    "upload-collection-thumbnail-background",
    options,
  );
};

export default useUploadCollectionThumbnailBackgroundMutation;
